(function () {
  function attachSrc(video) {
    if (!video) return;
    const src = video.getAttribute('data-src');
    if (!src) return;
    if (video.getAttribute('src') === src) return;
    const existing = video.querySelector('source[src]');
    if (existing) return;
    video.src = src;
  }

  function fromEventTarget(target) {
    if (!target || !target.closest) return null;
    const wrap = target.closest('[data-media-type="video"]');
    if (!wrap) return null;
    return wrap.querySelector('video');
  }

  document.addEventListener(
    'click',
    function (event) {
      attachSrc(fromEventTarget(event.target));
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      attachSrc(fromEventTarget(event.target));
    },
    true
  );

  const GALLERY_VIDEO = '[data-media-type="video"] video, video.la-gallery-video';

  const offscreenObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio < 0.2 && !entry.target.paused) entry.target.pause();
            });
          },
          { threshold: [0, 0.2] }
        )
      : null;

  document.addEventListener(
    'play',
    function (event) {
      if (event.target && event.target.matches && event.target.matches(GALLERY_VIDEO)) {
        attachSrc(event.target);
        if (offscreenObserver) offscreenObserver.observe(event.target);
      }
    },
    true
  );

  document.addEventListener(
    'error',
    function (event) {
      const video = event.target;
      if (!video || !video.matches || !video.matches(GALLERY_VIDEO)) return;
      const fallback = video.getAttribute('data-fallback-src');
      const current = video.getAttribute('src');
      if (!fallback || !current || current === fallback) return;
      video.setAttribute('data-src', fallback);
      video.src = fallback;
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    },
    true
  );

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    document.querySelectorAll(GALLERY_VIDEO).forEach(function (video) {
      if (!video.paused) video.pause();
    });
  });

  const PLAY_BUTTON = '.la-video-play';

  function playButtonOf(video) {
    const media = video.closest('.media');
    return media ? media.querySelector(PLAY_BUTTON) : null;
  }

  function quietPlay(video) {
    const attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;
      const button = event.target.closest && event.target.closest(PLAY_BUTTON);
      if (!button) return;
      const media = button.closest('.media');
      const video = media && media.querySelector('video.la-gallery-video');
      if (!video) return;
      event.preventDefault();
      event.stopPropagation();
      attachSrc(video);
      video.controls = true;
      quietPlay(video);
    },
    true
  );

  document.addEventListener(
    'play',
    function (event) {
      const video = event.target;
      if (!video || !video.matches || !video.matches('video.la-gallery-video')) return;
      const button = playButtonOf(video);
      if (button) button.hidden = true;
      video.controls = true;
    },
    true
  );

  ['pause', 'ended'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        const video = event.target;
        if (!video || !video.matches || !video.matches('video.la-gallery-video')) return;
        const button = playButtonOf(video);
        video.controls = false;
        if (button) button.hidden = false;
      },
      true
    );
  });

  const LIGHTBOX_TRIGGER =
    '.lightbox-media-container .lightbox-image, .la-photo-strip .custom-expansion-icon-wrapper, #staticExpandBtn';

  function lightboxItems(container) {
    return Array.from(container.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')).filter(
      function (item) {
        return item.querySelector('.lightbox-image, video.la-gallery-video');
      }
    );
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function slideData(item) {
    const link = item.querySelector('.lightbox-image');
    if (link) {
      const thumb = link.querySelector('img');
      return {
        src: link.getAttribute('data-pswp-src'),
        width: Number(link.getAttribute('data-pswp-width')) || 0,
        height: Number(link.getAttribute('data-pswp-height')) || 0,
        msrc: thumb ? thumb.currentSrc || thumb.src : undefined,
        alt: thumb ? thumb.alt : ''
      };
    }
    const video = item.querySelector('video.la-gallery-video');
    const src = video.getAttribute('data-fallback-src') || video.getAttribute('data-src');
    return {
      html:
        '<div class="la-pswp-video"><video playsinline controls preload="metadata" poster="' +
        escapeAttr(video.getAttribute('poster')) +
        '" src="' +
        escapeAttr(src) +
        '"></video></div>'
    };
  }

  function startIndex(trigger, container, items) {
    if (trigger.id === 'staticExpandBtn') {
      const active = container.querySelector('.swiper-slide-active');
      if (!active) return 0;
      const found = items.findIndex(function (item) {
        return item.dataset.slideIndex === active.dataset.slideIndex;
      });
      return Math.max(0, found);
    }
    return items.indexOf(trigger.closest('.product__media-item'));
  }

  function syncLightboxVideos(pswp) {
    const current = pswp.currSlide && pswp.currSlide.container;
    pswp.element.querySelectorAll('.la-pswp-video video').forEach(function (video) {
      if (current && current.contains(video)) {
        quietPlay(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function openLightbox(container, index) {
    const chunk = window.flu && window.flu.chunks && window.flu.chunks.photoswipe;
    if (!chunk) return false;
    const items = lightboxItems(container);
    document.querySelectorAll(GALLERY_VIDEO).forEach(function (video) {
      if (!video.paused) video.pause();
    });
    import(chunk).then(function (module) {
      const icons = (window.theme && window.theme.icons) || {};
      const options = {
        dataSource: items.map(slideData),
        pswpModule: module.PhotoSwipe,
        mainClass: 'pswp--product-lightbox',
        bgOpacity: 1,
        showHideAnimationType: 'fade'
      };
      if (icons.chevron) {
        options.arrowPrevSVG = icons.chevron;
        options.arrowNextSVG = icons.chevron;
      }
      if (icons.close) options.closeSVG = icons.close;
      if (icons.zoom) options.zoomSVG = icons.zoom;

      const lightbox = new module.PhotoSwipeLightbox(options);
      lightbox.on('firstUpdate', function () {
        if (items.length === 1) lightbox.pswp.element.classList.add('pswp--is-single-image');
      });
      lightbox.on('afterInit', function () {
        const pswp = lightbox.pswp;
        pswp.on('change', function () { syncLightboxVideos(pswp); });
        pswp.on('openingAnimationEnd', function () { syncLightboxVideos(pswp); });
        pswp.on('close', function () {
          pswp.element.querySelectorAll('.la-pswp-video video').forEach(function (video) {
            video.pause();
          });
        });
        // Let the native video controls work instead of PhotoSwipe treating the press as a swipe.
        pswp.on('pointerDown', function (e) {
          const target = e.originalEvent && e.originalEvent.target;
          const video = target && target.closest && target.closest('.la-pswp-video video');
          if (!video) return;
          const rect = video.getBoundingClientRect();
          if (e.originalEvent.clientY > rect.bottom - 64) e.preventDefault();
        });
      });
      lightbox.init();
      lightbox.loadAndOpen(index);
    });
    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;
      const trigger = event.target.closest && event.target.closest(LIGHTBOX_TRIGGER);
      if (!trigger) return;
      const container = trigger.closest('.lightbox-media-container');
      if (!container) return;
      const items = lightboxItems(container);
      const index = startIndex(trigger, container, items);
      if (index < 0) return;
      event.preventDefault();
      event.stopPropagation();
      openLightbox(container, index);
    },
    true
  );
})();
